// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-SidebarMenu-styles___menu--zxIFF {
  flex: 1;
}

.components-SidebarMenu-styles___iconWrapper--K9n_4 {
  margin-right: 0 !important;
  min-width: 23px !important;
  text-align: center;
  display: block !important;
}

.components-SidebarMenu-styles___listIcon--OL3aV {
  fill: #fff;
  color: #fff;
  margin: 0;
}

.components-SidebarMenu-styles___listItem--UsIaV {
  cursor: pointer;
  padding: 0 24px;
}

.components-SidebarMenu-styles___listItem--UsIaV > div + div {
    padding: 13px;
    padding-right: 16px;
  }

.components-SidebarMenu-styles___listItem--UsIaV > div + div span {
      line-height: 1.15rem;
    }

.components-SidebarMenu-styles___listItem--UsIaV:hover {
    background-color: rgba(95, 102, 112, 0.4) !important;
  }

.components-SidebarMenu-styles___active--m8NVO {
  background-color: rgba(95, 102, 112, 0.4) !important;
}

.components-SidebarMenu-styles___listItemText--v72s3 span {
    color: #fff;
    font-size: 15px;
  }

.components-SidebarMenu-styles___icon--pYLD3 {
  width: 16px;
  height: 16px;
}
`, "",{"version":3,"sources":["webpack://./components/SidebarMenu/styles.pcss"],"names":[],"mappings":"AAAA;EACE,OAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;AAajB;;AAZE;IACE,aAAa;IACb,mBAAmB;EAKrB;;AAHE;MACE,oBAAoB;IACtB;;AAGF;IACE,oDAAoD;EACtD;;AAGF;EACE,oDAAoD;AACtD;;AAGE;IACE,WAAW;IACX,eAAe;EACjB;;AAGF;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".menu {\n  flex: 1;\n}\n\n.iconWrapper {\n  margin-right: 0 !important;\n  min-width: 23px !important;\n  text-align: center;\n  display: block !important;\n}\n\n.listIcon {\n  fill: #fff;\n  color: #fff;\n  margin: 0;\n}\n\n.listItem {\n  cursor: pointer;\n  padding: 0 24px;\n  > div + div {\n    padding: 13px;\n    padding-right: 16px;\n\n    span {\n      line-height: 1.15rem;\n    }\n  }\n\n  &:hover {\n    background-color: rgba(95, 102, 112, 0.4) !important;\n  }\n}\n\n.active {\n  background-color: rgba(95, 102, 112, 0.4) !important;\n}\n\n.listItemText {\n  span {\n    color: #fff;\n    font-size: 15px;\n  }\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `components-SidebarMenu-styles___menu--zxIFF`,
	"iconWrapper": `components-SidebarMenu-styles___iconWrapper--K9n_4`,
	"listIcon": `components-SidebarMenu-styles___listIcon--OL3aV`,
	"listItem": `components-SidebarMenu-styles___listItem--UsIaV`,
	"active": `components-SidebarMenu-styles___active--m8NVO`,
	"listItemText": `components-SidebarMenu-styles___listItemText--v72s3`,
	"icon": `components-SidebarMenu-styles___icon--pYLD3`
};
module.exports = ___CSS_LOADER_EXPORT___;
